import { postToParent } from "@/utils";
import { Pressable } from "native-base";
import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";
import RModal from "react-modal";

export interface IModal {
  children: React.ReactNode;
  isOpen: boolean;
  onRequestClose(): void;
  maxWidth?: number;
  zIndex?: number;
  overflow?: React.CSSProperties["overflowY"];
  overflowY?: React.CSSProperties["overflowY"];
}

function Modal(props: IModal) {
  const {
    children,
    isOpen = false,
    onRequestClose,
    maxWidth = 450,
    zIndex = 0,
    overflow = "auto",
    overflowY = "auto",
  } = props;

  useEffect(() => {
    if (isOpen) {
      postToParent({ event: "MODAL_OPEN" });
    }
  }, [isOpen]);

  return (
    <RModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0,15,50,0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: zIndex || undefined,
        },
        content: {
          inset: "unset",
          padding: 0,
          boxShadow: "rgb(0 0 0 / 20%) 0px 1px 1.41px",
          borderRadius: "4px",
          border: "none",
          maxWidth: `${maxWidth}px`,
          width: "90%",
          maxHeight: "90vh",
          overflow,
          overflowY,
          position: "relative",
        },
      }}>
      {!!onRequestClose && (
        <Pressable
          onPress={onRequestClose}
          position="absolute"
          top={4}
          right={4}
          backgroundColor="rgba(0,0,0,0.04)"
          borderRadius={9999}
          padding={2}
          color="#1f2937"
          zIndex={1}>
          <FiX size={18} />
        </Pressable>
      )}

      {children}
    </RModal>
  );
}

export default React.memo(Modal);
